(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSBaja', SSBaja);

    SSBaja.$inject = ['$resource', 'DateUtils'];

    function SSBaja ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-bajas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fechaBaja = DateUtils.convertDateTimeFromServer(data.fechaBaja);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
